import Api from '../../classes/Api/Api';
import URL from '../../classes/Url/URL';

const AwaiService = () => {
  const getDmrv = async (propertyId) => {
    try {
      const api = new Api(
        `${URL.URL_SERVER}/properties/${propertyId}/dmrv`
      );
      const response = await api.get();
      return response?.data || null;
    } catch (err) {
      console.error('Error fetching DMRV:', err);
      return null;
    }
  };

  return {
    getDmrv,
  };
};

export default AwaiService;